import { buildQueryString } from '../../util/string'
import { devMode } from '../../util/env'
import l10n from '../../shared/l10n'
const { lang } = l10n

const LOAD_SUBSIDIARIES_SUGGESTIONS = 'LOAD_SUBSIDIARIES_SUGGESTIONS'
const LOAD_SUBSIDIARIES_SUGGESTIONS_SUCCESS =
  'LOAD_SUBSIDIARIES_SUGGESTIONS_SUCCESS'
const LOAD_SUBSIDIARIES_SUGGESTIONS_FAILURE =
  'LOAD_SUBSIDIARIES_SUGGESTIONS_FAILURE'

const initialState = {
  data: null,
  error: null,
  isLoading: false,
  isLoaded: false,
}

export default (state = initialState, action = {}) => {
  const { type, payload = {} } = action

  switch (type) {
    case LOAD_SUBSIDIARIES_SUGGESTIONS:
      return {
        ...state,
        isLoading: true,
      }
    case LOAD_SUBSIDIARIES_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: payload,
      }
    case LOAD_SUBSIDIARIES_SUGGESTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    default:
      return state
  }
}

export const loadSubsidiariesSuggestions = () => (dispatch, getState) => {
  const state = getState()
  const isLoaded = state.subsidiariesSuggestions.isLoaded

  if (isLoaded) {
    return
  }

  const query = buildQueryString({
    lang,
  })

  dispatch({
    type: LOAD_SUBSIDIARIES_SUGGESTIONS,
  })

  return fetch(
    `/wp-json/dhsv/v1/estate-filters/subsidiaries-suggestions?${query}`
  )
    .then(response => {
      if (response.status !== 200) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        dispatch({
          payload: json,
          type: LOAD_SUBSIDIARIES_SUGGESTIONS_SUCCESS,
        })

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
        },
        type: LOAD_SUBSIDIARIES_SUGGESTIONS_FAILURE,
      })
      throw error
    })
}
